import React from "react";
import { SignUp } from "../../Users";
import { Loader } from "../../Shared";
import { Container } from "./style.ts";
import "./index.css";

const LogInLayout = (props) => (
  <Container>
    <SignUp {...props} />
    <Loader />
  </Container>
);

export default LogInLayout;
